export default class UnauthorizedException extends Error {
    statusCode: number;

    constructor(message: string, statusCode: number) {
        super(message);
        this.name = 'Unauthorized Exception';
        this.statusCode = statusCode;
    }
}